import React from "react";
import LogoMarianne from "../../assets/images/logo_marianne.png";
import AccessButtonAtm from "../../atoms/access-button/AccessButtonAtm";
import * as eva from "eva-icons";

const SupportUsCpnt = () => {
  return (
    <React.Fragment>
      <article id="soutenir" className="support-us">
        <section className="su-container">
          <div className="suc-infos-wrapper">
            <div className="suciw-private info-item">
              <h3 className="ii-title">À quoi servent vos dons ?</h3>
              <div className="ii-list">
                <div className="ii-list-item">
                  <p className="ii-text">À LUTTER CONTRE</p>
                  <ul className="ii-text list particulier">
                    <li>Le sexisme</li>
                    <li>Le harcèlement</li>
                    <li>Les discriminations</li>
                  </ul>
                </div>
                <div className="ii-list-item">
                  <p className="ii-text">À AGIR POUR</p>
                  <ul className="ii-text list particulier">
                    <li>L'égalité des chances</li>
                    <li>La mixité des métiers</li>
                    <li>La qualité de vie au travail</li>
                  </ul>
                </div>
              </div>
              {/* <p className="ii-info">Pour faire un don, contactez-nous :</p>
              <a href="mailto:contact.toogether@gmail.com" className="ii-mail">
                <i data-eva-fill="#B93C13" data-eva="email-outline"></i>
                <span>contact.toogether@gmail.com</span>
              </a> */}
              <div className="ii-big-round">
                <div className="iibr-inside-round"></div>
              </div>
            </div>
            <div className="suciw-pro info-item">
              <h3 className="ii-title">Déduction fiscale</h3>
              <p className="ii-subtitle">TOOGETHER est reconnue d’intérêt général par l’administration fiscale.<br/>Chaque don ouvre droit à une déduction fiscale totalement sécurisée.</p>
              <div className="ii-list pro">
                <div className="ii-list-item">
                  <p className="ii-text subtitle">PARTICULIERS</p>
                  <p className="ii-text">Votre don ouvre droit à une réduction d’impôt de 66% (art. 200 CGI)&nbsp;:</p>
                  <ul className="ii-text list">
                    <li>Vous donnez 100 €</li>
                    <li>Vous déduisez 66 € de vos impôts</li>
                    <li>Vous ne payez en réalité que 34 €</li>
                  </ul>
                </div>
                <div className="ii-list-item">
                  <p>&nbsp;</p>
                  <p className="ii-text subtitle">ENTREPRISES</p>
                  <p className="ii-text">Votre don est défiscalisé à hauteur de 60% (art. 238 bis CGI).</p>
                </div>
              </div>
              {/* <p className="ii-info">Pour faire un don, contactez-nous :</p>
              <a href="mailto:contact.toogether@gmail.com" className="ii-mail">
                <i data-eva-fill="#E7AE11" data-eva="email-outline"></i>
                <span>contact.toogether@gmail.com</span>
              </a> */}

              <div className="ii-big-round">
                <div className="iibr-inside-round"></div>
              </div>
            </div>
          </div>
        </section>
        <div className="su-banner">
          <div className="sub-container">
            <div className="subc-text">
              <h2 className="subct-title">Soutenir, c'est déjà agir</h2>
              <p className="subct-text">Prenez part à un grand élan d’engagement,</p>
              <p className="subct-text">en encourageant la seule ONG réunionnaise d’égalité des chances en entreprise.</p>
            </div>
            <img className="subc-image" src={LogoMarianne} alt="Association reconnue d'intérêt général" />
          </div>
        </div>
      </article>
      <div className="button-container">
        <AccessButtonAtm textButton="Faire un don" />
      </div>
    </React.Fragment>
  );
};

export default SupportUsCpnt;
